<script>
  import Intersection from "$lib/Intersection.svelte";

  export let block;
</script>

<div class="light py-16">
  <div class="max-w-content mx-auto">
    <div class="flex -m-4 flex-wrap">
      {#each block.fields as { customer }}
        <Intersection
          class="p-4 w-1/2 md:w-1/3 lg:w-1/4 flex items-center justify-center"
          let:intersecting
          top={500}
          bottom={500}
        >
          <div class="constraint">
            {#if intersecting}
              <img
                class="block absolute w-full h-full grayscale"
                src={customer.logo.url}
                alt={customer.customer[0].text}
              />
            {/if}
          </div>
        </Intersection>
      {/each}
    </div>
  </div>
</div>

<style>
  .constraint {
    @apply h-0 relative;
    width: 50%;
    padding-bottom: 50%;
  }
</style>
